@if (mapLoaded) {
  @let tooltipText = ("maps.anzeigePlanZu" | translate) + " " + tooltip;
  @if (isTopomaps) {
    <ng-container>
      <a
        [disableTooltip]="false"
        [ngbTooltip]="tooltipText"
        [placement]="'top-end'"
        container="body"
        style="vertical-align: center; cursor: pointer; text-decoration: none"
        ><i class="far fa-map fa-1x"></i>
      </a>
    </ng-container>
  } @else {
    <span>
      <a
        [disableTooltip]="false"
        [ngbTooltip]="tooltipText"
        [placement]="'top'"
        class="dokulinkButton"
        container="body"
        style="color: black">
        <span aria-hidden="true" class="far fa-map fa-1x"></span>
      </a>
    </span>
  }
}
